const NBSP = ' '

const formatter = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 })

/**
 * Сумма без валюты: `500 000`, разряды — неразрывным пробелом во всех языках.
 *
 * Разделитель фиксирован намеренно: английская локаль дала бы запятую, а формат
 * денег в продукте один (раздел 25). Валютное слово (`сум` / `so'm` / `UZS`) —
 * отдельной строкой из словаря: меняется слово, а не число.
 */
export const formatAmount = (value: number): string =>
  formatter
    .formatToParts(value)
    .map((part) => (part.type === 'group' ? NBSP : part.value))
    .join('')
